import React, { Component } from "react";
import ReactDOM from "react-dom";
import "./LBGroup.css";
import * as languageSettings from "../Language/languageSettings";
import t from "../Language/language";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Config } from "../../Config";
import Api from "../../Api";
import { ButtonToolbar, DropdownButton, MenuItem } from "react-bootstrap";
import Online from "../../images/connection_online.png";
import Offline from "../../images/connection_offline.png";
import Search from "../../images/search.jpg";
import AuthenticationService from "../Security/AuthenticationService";
import { Modal } from "react-bootstrap";
import ParticipantStoresPopover from "./PaticipantStoresPopover";
import ReCAPTCHA from "react-google-recaptcha";
import "../Group/ReportGroup.css";
import { CommonConstants } from "../../Constants";
import { isNullOrUndefined } from "util";
const MenuIcon = require("../../images/lbGroupItemMenu.png");

export default class LeaderboardMembers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      language: languageSettings.getCurrentLanguage(),
      data: [],
      uuid: null,
      settingsDropdown: false,
      settingsDropdownID: 0,
      selectedGroupAdmin: null,
      showLoader: "hidden",
      showInvite: false,
      showInviteConfirm: false,
      showStoreAssignment: false,
      showStoreAssignmentConfirm: false,
      inviteeEmail: null,
      storeUidArray: [],
      // State parameters for participant Stores popover.
      showParticipantStoresPopover: false,
      selectedParticipantCompany: null,
      selectedParticipantStores: [],
      showInviteMember: false,
      showRemoveMember: false,
      showUpdateOwner: false,
      showInviteResponse: false,
      removeModalWarning: "",
      updateOwnerModalWarning: "",
      selectedOwner: {},
      memberRemovalData: {
        ParticipantID: null,
        GroupUID: null,
        isAdmin: null,
        memberCount: 0,
      },
      inviteResponseData: {
        GroupUID: null,
        userEmail: null,
        acceptedGroup: null,
        InvitedBy_UserUID: null,
      },
      showInviteError: false,
      groupNotSelectedError: false,
      showInviteEmailError: false,
      showInvalidTitleError: false,
      emailLanguage: "English",
      showEmailLanguageError: false,
      inviteeToMakeOwner: null,
    };
  }

  render() {
    const { language } = this.state;
    return (
      <div>
        <table>
          <tbody>
            <tr className="theader clear">
              <th id="brand_space" className={this.props.isAdmin === "true" ? "" : "hidden"}>
                <span onClick={this.props.toggleInviteModal} className="invite-group-btn cursor-pointer actcol paddingOnRight">
                  {t[language].Invite}
                  {" +"}
                </span>
              </th>
              <th className="taller-header">
                <span id="Company" className="cursor-pointer actcol paddingOnRight">
                  {t[language].company}
                </span>
              </th>
              <th className="taller-header">
                <span id="MembersStatus" className="cursor-pointer actcol paddingOnRight">
                  {t[language].MembersStatus}
                </span>
              </th>
              <th className={this.props.isAdmin === "false" || this.props.isDefault === 1 ? "hidden" : "taller-header"} id="brand_space">
                <span id="User_Name" className=" cursor-pointer actcol paddingOnRight">
                  {t[language].LeaderboardOwner}
                </span>
              </th>
              <th className={"taller-header" + (this.state.uuid == this.state.selectedGroupAdmin ? "" : "hidden")}>
                <span id="MembersRemove" className="cursor-pointer actcol paddingOnRight">
                  {t[language].Remove}
                </span>
              </th>
            </tr>
            {this.renderMembers()}
          </tbody>
        </table>
        {this.renderParticipantStoresPopover()}
        {this.renderRemoveMemberModal()}
        {this.renderUpdateOwnerModal()}
      </div>
    );
  }

  renderMembers() {
    let self = this;
    const { language } = self.state;
    let groupMembers = self.props.members;
    if (groupMembers != null && groupMembers[0] != null && groupMembers[0].CompanyUID != null) {
      let memberRows = groupMembers.map(function(member, index) {
        let isAdmin = self.props.isAdmin === "true" && member.Status != "Owner";
        let isCompanyUser = member.CompanyUID === self.props.CompanyUID && member.Status != "Owner";
        let dispRemove = isCompanyUser || isAdmin;
        return (
          <tr className={"tdata clear" + (index % 2 == 1 ? " odd-row" : " even-row")} key={member.CompanyUID}>
            <td className={self.props.isAdmin === "true" ? "" : "hidden"} />
            <td>
              <span
                // Make company name unclickable if status is Pending or Denied.
                className="cursor-pointer"
              >
                {member.Status === "Owner" || member.Status === "Accepted" ? (
                  <a
                    ref={companyLink => {
                      self.target = companyLink;
                    }}
                    onClick={event => self.triggerParticipantStoresPopover(event, member)}
                  >
                    {member.Company}
                  </a>
                ) : (
                  member.Company
                )}
              </span>
            </td>
            <td>{t[language][member.Status]}</td>
            <td className={self.props.isAdmin === "false" || self.props.isDefault === 1 ? "hidden" : ""}>
              {member.Status === "Owner" ? (
                t[language].Owner
              ) : (
                <a
                  className={member.Status === "Pending" || member.Status === "Denied" ? "hidden" : "cursor-pointer"}
                  onClick={e => self.toggleModal(e, member.ParticipantID, "updateOwner")}
                >
                  {t[language].MakeAdmin}
                </a>
              )}
            </td>
            <td>
              <div className={dispRemove ? "red-text cursor-pointer" : "hidden"} onClick={e => self.toggleModal(e, member.ParticipantID, "removeMember")}>
                X
              </div>
            </td>
          </tr>
        );
      });
      return memberRows;
    } else {
      return (
        <tr>
          <td className="no-groups">{t[language].noMembersFound}</td>
        </tr>
      );
    }
  }

  //Popup modal that let's the user decide if they are sure that they want to change a LB's admin
  renderUpdateOwnerModal() {
    const { language } = this.state;
    let showUpdateOwner = this.state.showUpdateOwner;
    let closeModal = () => {
      this.setState({ showUpdateOwner: false });
    };
    let cancelUpdateOwner = () => {
      this.setState({ showUpdateOwner: false });
    };
    return (
      <Modal show={showUpdateOwner} onHide={closeModal} aria-labelledby="ModalHeader">
        <Modal.Header closeButton>
          <Modal.Title id="ModalHeader" className="store-modal-content">
            {t[language].ChooseNewAdmin}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <span className="clear">{t[language].areYouSureYouWantToChangeMakeGroupMemberAnAdmin} </span>
          <span className="red-text">{this.state.updateOwnerModalWarning}</span>
          <div className="formattingConfirmCancelButtons">
            <button className="btn btn-primary fright paddingOnRight" onClick={cancelUpdateOwner}>
              {t[language].cancel}
            </button>
            <button className="btn btn-primary" onClick={e => this.confirmUpdateOwner(e)}>
              {t[language].confirm}
            </button>
          </div>
        </Modal.Body>
      </Modal>
    );
  }

  //Fires off the API call to change the LB's owner
  async confirmUpdateOwner(e) {
    const { language } = this.state;
    if (this.state.inviteeToMakeOwner != undefined && this.props.members.length > 1) {
      this.api = new Api();
      this.authService = new AuthenticationService(Config.authBaseUrl);
      let url = Config.apiBaseUrl + CommonConstants.apiUrls.updateLBGroupOwner + "/" + this.state.inviteeToMakeOwner;
      await this.api.getData(url, result => {
        console.log("Operation Success: ", result);
        window.location.href = `/leaderBoards`;
      });
      this.setState({ showUpdateOwner: false });
    } else {
      this.setState({ updateOwnerModalWarning: t[language].error + " " + t[language].youAreNotAllowedToMakeThisUserAnOwner });
    }
  }

  renderRemoveMemberModal() {
    const { language } = this.state;
    let showRemoveMember = this.state.showRemoveMember;
    let closeModal = () => {
      this.setState({ showRemoveMember: false });
    };
    let cancelRemove = () => {
      this.setState({ showRemoveMember: false });
    };
    return (
      <Modal show={showRemoveMember} onHide={closeModal} aria-labelledby="ModalHeader">
        <Modal.Header closeButton>
          <Modal.Title id="ModalHeader" className="store-modal-content">
            {t[language].confirmRemoval}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <span className="clear">{t[language].areYouSureYouWantToRemoveThisGroupMember} </span>
          <span className="red-text">{this.state.removeModalWarning}</span>
          <div className="formattingConfirmCancelButtons">
            <button className="btn btn-primary fright paddingOnRight" onClick={cancelRemove}>
              {t[language].cancel}
            </button>
            <button className="btn btn-primary" onClick={e => this.confirmRemoveMember(e)}>
              {t[language].confirm}
            </button>
          </div>
        </Modal.Body>
      </Modal>
    );
  }

  // Trigger Popover when a participant is selected and populate state with respective store list and company name.
  triggerParticipantStoresPopover(event, member) {
    if (member.Status === "Owner" || member.Status === "Accepted") {
      const selectedParticipantStores = this.props.assignedStores.filter(store => store.CompanyUID === member.CompanyUID);
      this.setState({ selectedParticipantStores });
    } else {
      this.setState({ selectedParticipantStores: [] });
    }

    this.setState({ selectedParticipantCompany: member.Company });
    this.setState({
      showParticipantStoresPopover: true,
    });
    this.setState({ selectedStoreTarget: event.target });
  }

  // Popover showing stores belonging to a valid participant.
  renderParticipantStoresPopover() {
    let closePopover = () => {
      this.setState(this.setState({ showParticipantStoresPopover: false }));
    };
    return (
      <ParticipantStoresPopover
        show={this.state.showParticipantStoresPopover}
        content={this.state.selectedParticipantStores}
        company={this.state.selectedParticipantCompany}
        language={this.state.language}
        target={() => ReactDOM.findDOMNode(this.state.selectedStoreTarget)}
        closePopover={closePopover}
      />
    );
  }

  async confirmRemoveMember(e) {
    const { language } = this.state;
    if (this.state.memberRemovalData.memberCount > 1) {
      this.api = new Api();
      this.authService = new AuthenticationService(Config.authBaseUrl);
      let url = Config.apiBaseUrl + CommonConstants.apiUrls.deleteLBGroupUser + "/" + this.state.memberRemovalData.ParticipantID;
      this.api.deleteData(
        url,
        data => {
          this.props.renderLBGroupDetails();

          this.props.getMembers();
        },
        error => {
          console.log(error);
        },
      );

      this.setState({ showRemoveMember: false });
    } else {
      this.setState({ removeModalWarning: t[language].error + " " + t[language].youcannotdeleteadminsorsolemembers });
    }
  }

  toggleModal(e, ParticipantID, modalType) {
    e.target.selected == false;
    if (modalType === "removeMember") {
      //Needs to know member ParticipantID, member groupUID, and number of members in the group
      this.setState({ showRemoveMember: !this.state.showRemoveMember });
      this.setState({
        memberRemovalData: {
          ParticipantID: ParticipantID,
          GroupUID: this.props.GroupUID,
          memberCount: this.props.members.length,
        },
      });
    } else if (modalType === "updateOwner") {
      //Needs to know the ParticipantID. Will take care of demoting current admin on serverside.
      this.setState({ showUpdateOwner: !this.state.showUpdateOwner });
      this.setState({ inviteeToMakeOwner: ParticipantID });
    } else {
      console.log("Error: Modal type not found");
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/LeaderBoard/leaderboardMembers.js